<template>
  <div class="archives">
    <div class="header">
      <div class="title">
        <ul>
          <li id="title-icon">
            <div></div>
            <span>年次レポート</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="section">
      <div class="container" v-if="loaded">
        <div id="button-area">
          <span class="btn-submit" @click="WorkRecordShow">作業実績</span>
        </div>
        <div id="button-area">
          <span class="btn-submit" @click="InformationRecordShow">お知らせ</span>
        </div>
        <div id="button-area">
          <span class="btn-submit" @click="LogRecordShow">作業ログ</span>
        </div>
        <div id="button-area">
          <span class="btn-submit" @click="WeatherHistoryShow">天気</span>
        </div>
        <!-- <div id="button-area" v-if="isWater">
          <span class="btn-submit" @click="WaterHistoryShow">水</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},

  mixins: [],

  props: {},

  data() {
    return {
      loaded: false,
      managementIds: {},
      isWater: false,
    };
  },

  async mounted() {
    this.$emit("hideMap");
    try {
      const acinfo = await this.showAccount(await this.showAccountID());
      this.isWater = this.isValidWater(acinfo);
    } catch (error) {
      console.log(error);
    }
    this.loaded = true;
  },

  methods: {
    ...mapActions(["showManagementID", "showAccount", "showAccountID"]),
    ...mapGetters(["getManagements"]),

    WorkRecordShow() {
      this.$router.push({
        name: "archives-work",
      });
    },
    InformationRecordShow() {
      this.$router.push({
        name: "archives-information",
      });
    },
    LogRecordShow() {
      this.$router.push({
        name: "archives-log",
      });
    },
    WeatherHistoryShow() {
      this.$router.push({
        name: "archives-weather",
      });
    },
    WaterHistoryShow() {
      this.$router.push({
        name: "archives-water",
      });
    },

    isValidWater(acinfo) {
      if (acinfo) {
        if (acinfo.admin === 1) {
          return true;
        }
        if (acinfo.display_mode) {
          if (acinfo.display_mode.water_management === 1) {
            return true;
          }
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss">
.archives {
  // .header {
  //   margin: 2rem;
  // }
  .section {
    overflow: auto;
    width: 80%;
    height: calc(100% - 130px);
    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      margin: 2rem;
      margin-left: auto;
      margin-right: auto;
    }
  }
  #button-area {
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }
  .btn-submit {
    display: block;
    background: var(--purple);
    font-size: 35px;
    text-align: center;
    width: 100%;
    max-width: 400px;
    height: 80px;
    border-radius: 10px;
    color: #fff;
    padding: 15px 20px;
    margin-bottom: 10px;
    cursor: pointer;
    &.disable {
      opacity: 0.5;
      cursor: inherit;
    }
  }

  select {
    height: 50px;
    border-radius: 10px;
    border: solid 1px var(--purple);
    padding: 0 38px 0 16px;
    font-size: 20px;
    font-weight: bold;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
      calc(100% - 10px) center;
    background-size: 25px 25px;
  }

  select:focus {
    background: url("~@/assets/icons/ic_dropdown.svg") no-repeat
      calc(100% - 10px) center var(--purple-tertiary);
    background-size: 25px 25px;
  }
  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    // padding: 0px 0px 0px 10px;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }
  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_folder.svg") no-repeat center center;
  }
}
</style>
